import { css } from '@emotion/core';

import { Theme } from 'src/design-system/theme';

import type { DefaultProps, RequiredProps } from './Toggle';

export const container = (props: DefaultProps & RequiredProps) => (theme: Theme) =>
  css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: ${theme.margins[props.marginBottom]}px;
    position: relative;
    width: 50px;

    ${theme.settings.rtl &&
    css`
      flex-direction: row-reverse;
    `}

    ${props.fullWidth &&
    css`
      width: 100%;
    `}

  ${props.disabled &&
    css`
      opacity: 0.4;
    `};
  `;

export const inputCss = (theme: Theme) => css`
  display: none;
`;

export const textCss = (theme: Theme) => css`
  user-select: none;
  cursor: pointer;
`;

export const loadingContainer = css`
  width: 50px;
`;

export const loading = (theme: Theme) => css`
  position: absolute;
  left: 0;
  top: 4px;
`;

export const toggleCss = (props: DefaultProps & RequiredProps) => (theme: Theme) =>
  css`
    height: 24px;
    width: 48px;
    min-width: 48px;
    user-select: none;

    ${!props.disabled &&
    css`
      cursor: pointer;
    `}

    border-radius: 12px;
    border-width: 1px;
    border-style: solid;
    position: relative;

    ${(props.leftLabel || (theme.settings.rtl && props.rightLabel)) &&
    css`
      margin-left: ${theme.margins.md}px;
    `};

    ${(props.rightLabel || (theme.settings.rtl && props.leftLabel)) &&
    css`
      margin-right: ${theme.margins.md}px;
    `};

    ${props.checked &&
    !props.dark &&
    css`
      background-color: ${theme.colors.accent};
      border-color: ${theme.colors.accent};
    `};

    ${!props.checked &&
    !props.dark &&
    css`
      background-color: ${theme.colors.light};
      border-color: ${theme.colors.grey40};
    `};

    ${props.dark &&
    css`
      background-color: ${theme.colors.light};
      border-color: ${theme.colors.dark};
    `};

    ${props.loading &&
    css`
      background-color: ${theme.colors.light};
      border-color: ${theme.colors.grey40};
    `};

    &:after {
      content: '';
      height: 16px;
      width: 16px;

      border-radius: 50%;
      display: block;
      top: 0;
      bottom: 0;
      left: 3px;
      right: initial;
      margin: auto 0;
      position: absolute;
      transition: transform 0.1s ${theme.easings.standard};

      ${props.checked &&
      !props.loading &&
      css`
        transform: translateX(24px);
      `};

      ${!props.dark &&
      css`
        background-color: ${theme.colors.grey40};
      `};

      ${props.checked &&
      !props.loading &&
      !props.dark &&
      css`
        transform: translateX(24px);
        background-color: ${theme.colors.light};
      `};

      ${props.dark &&
      css`
        background-color: ${theme.colors.dark};
      `};

      ${props.loading &&
      `
        background-color: transparent;
      `}
    }
  `;
